import type { ReactNode } from 'react';
import { Link, useLocation } from 'react-router';
import { errorMessage, isUnauthenticated } from '../api.js';

/** An error from the API, in words. A 401 offers the way back in. */
export function ErrorNotice({ error }: { error: unknown }) {
  const location = useLocation();
  if (error === undefined || error === null) return null;
  if (isUnauthenticated(error)) {
    const next = location.pathname + location.search;
    return (
      <div className="notice notice-error" role="alert">
        Your sign-in has expired. <Link to={`/sign-in?next=${encodeURIComponent(next)}`}>Sign in again</Link>.
      </div>
    );
  }
  return (
    <div className="notice notice-error" role="alert">
      {errorMessage(error)}
    </div>
  );
}

export function Notice({ kind = 'info', children }: { kind?: 'info' | 'warn' | 'ok'; children: ReactNode }) {
  return <div className={`notice notice-${kind}`}>{children}</div>;
}

export function Loading({ what = 'Loading' }: { what?: string }) {
  return (
    <p className="subtle" role="status">
      {what}…
    </p>
  );
}
